// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__37kyB","row":"ProcedureTreatmentSummary_row__rxmjE"};